<template>
  <div>
    <div class="page-header clear-filter" filter-color="orange">
      <parallax
        class="page-header-image"
        style="background-image:url('img/bg5.jpg')"
      >
      </parallax>
      <div class="container">
        <h2 class="title">Contact</h2>
          <h3 class="title">Ready to elevate your perspective?</h3>
                <p>Email</p>  
                <h3><a href="mailto:nacs716@gmail.com">nacs716@gmail.com</a></h3>
                <p>Phone</p>  
                <h3><a href="tel:716-479-2927">716.479.2927</a></h3>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="button-container">
          <a
            href="https://www.facebook.com/NACS716"
            class="btn btn-default btn-round btn-lg btn-icon"
            rel="tooltip"
            title="Follow me on Facebook"
          >
            <i class="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.instagram.com/nacs716"
            class="btn btn-default btn-round btn-lg btn-icon"
            rel="tooltip"
            title="Follow me on Instagram"
          >
            <i class="fab fa-instagram"></i>
          </a>
          <a
            href="https://twitter.com/nacs716"
            class="btn btn-default btn-round btn-lg btn-icon"
            rel="tooltip"
            title="Follow me on Twitter"
          >
            <i class="fab fa-twitter"></i>
          </a>
        </div>
      </div>
      <div class="container">
        <div class="row">
            <div class="col-md-12 ml-auto mr-auto">
                <div class="row collections">
                    <div class="col-md-12">
                    <img width="100%" src="/img/sphere.jpg" class="img-raised" />
                    </div>
                </div>
            </div>
        </div>
      </div>      
    </div>
  </div>
</template>
<script>
export default {
  name: 'contact',
  bodyClass: 'profile-page',
  components: {
  }
};
</script>
<style></style>
